<template>
  <path
    d="M12 8.41019L15.89 12.3002C16.28 12.6902 16.91 12.6902 17.3 12.3002C17.69 11.9102 17.69 11.2802 17.3 10.8902L12.71 6.30019C12.32 5.91019 11.69 5.91019 11.3 6.30019L6.7 10.8902C6.31 11.2802 6.31 11.9102 6.7 12.3002C7.09 12.6902 7.72 12.6902 8.11 12.3002L12 8.41019ZM7 18.0002H17C17.55 18.0002 18 17.5502 18 17.0002C18 16.4502 17.55 16.0002 17 16.0002H7C6.45 16.0002 6 16.4502 6 17.0002C6 17.5502 6.45 18.0002 7 18.0002Z"
  />
</template>
